import toast, { NotifyType } from 'utils/toast';
import { API_POST_QA_RATE } from 'config/data';
import { AppState } from 'interface/stateApp';
import { rate } from 'model/QnA';
import React, { useState } from 'react';
import { ACTION_RESPONSE_REPORT, MEDIA_TYPE, QA_TICKET_STATUS } from 'utils/data';
import { fetchApiPut, getQaReport } from 'utils/helper';

interface FormProps {
  stateApp: AppState;
  setStateApp: React.Dispatch<React.SetStateAction<AppState>>;
  ticket?: any;
  onData?: any;
}

const QaReport = ({ stateApp, setStateApp, ticket, onData }: FormProps) => {
  const [rate, setRate] = useState<Partial<rate>>({});

  const handleSendRate = async (action: string) => {
    if (ticket?.id === undefined) {
      toast(NotifyType.ERROR, 'Có lỗi xảy ra!');
      return;
    }
    if (rate?.response === undefined) {
      toast(NotifyType.WARNING, 'Vui lòng không để trống!');
      return;
    }
    var data = getQaReport(ticket?.rates);
    var status = '';
    if (data === undefined) {
      toast(NotifyType.ERROR, 'Report null!');
      return;
    }
    if (action === ACTION_RESPONSE_REPORT.AGREE) {
      data = { ...data, response: rate?.response, action: ACTION_RESPONSE_REPORT.AGREE };
      status = QA_TICKET_STATUS.PROCESS;
    } else {
      data = { ...data, response: rate?.response, action: ACTION_RESPONSE_REPORT.RESPONSE };
      status = QA_TICKET_STATUS.CLOSE;
    }
    const response = await fetchApiPut(`${API_POST_QA_RATE}/${data?.id}`, data, MEDIA_TYPE.JSON);
    if (response !== null) {
      toast(NotifyType.SUCCESS, 'Gửi phản hồi thành công!');
      const updatedRates = ticket.rates.map((rate: any) => {
        if (rate.id === data.id) {
          return { ...rate, ...data };
        }
        return rate;
      });
      const ticketUpdate = { ...ticket, rates: updatedRates, status: status };
      onData(ticketUpdate);
    } else {
      toast(NotifyType.ERROR, 'Có lỗi xảy ra');
    }
    setStateApp({ ...stateApp, showReportForm: false });
  };
  return (
    <div className="p-4 max-w-lg mx-auto bg-white rounded-lg">
      <div className="text-[24px] font-medium text-left text-[#3D0B3E]">Phản hồi báo cáo</div>
      <div className="mb-4 mt-4">
        <div className="mb-2 text-left text-[16px] text-[#3D0B3E]">Nội dung báo cáo</div>
      </div>
      <div className="mb-4">
        <textarea
          placeholder="Nhập ..."
          className="w-full p-2 border rounded-md resize-none outline-none"
          value={getQaReport(ticket?.rates) !== undefined ? getQaReport(ticket?.rates)?.message : ''}
          readOnly
        ></textarea>
      </div>
      <div className="mb-4 mt-4">
        <div className="mb-2 text-left text-[16px] text-[#3D0B3E]">Nội dung phản hồi</div>
      </div>
      <div className="mb-4">
        <textarea
          placeholder="Nhập ..."
          className="w-full p-2 border rounded-md resize-none outline-none"
          value={rate?.response}
          onChange={(e) => setRate({ ...rate, response: e.target.value })}
        ></textarea>
      </div>
      <div className="flex items-center justify-center gap-10 mt-5">
        <button
          className="w-24 p-2 bg-gray-300 text-gray-700 rounded-full"
          onClick={() => handleSendRate(ACTION_RESPONSE_REPORT.AGREE)}
        >
          Đồng ý
        </button>
        <button
          className="w-24 p-2 text-white rounded-full bg-[#410b43]"
          onClick={() => handleSendRate(ACTION_RESPONSE_REPORT.RESPONSE)}
        >
          Phản hồi lại
        </button>
      </div>
    </div>
  );
};

export default QaReport;
